import { ChangeDetectionStrategy, Component, OnInit, inject } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../../../../core/services/auth.service';
import { CompanyService } from '../../../../core/services/company.service';
import { DialogService } from '../../../../shared/services/dialog.service';

/** 077 · «Cerrando sesión…» → signOut → /login (reemplaza el historial). */
@Component({
  selector: 'app-logout-page',
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `<app-process-screen text="Cerrando sesión…" />`,
})
export class LogoutPage implements OnInit {
  private auth = inject(AuthService);
  private companies = inject(CompanyService);
  private dialog = inject(DialogService);
  private router = inject(Router);

  async ngOnInit(): Promise<void> {
    this.dialog.dismissAll();
    const minDelay = new Promise(r => setTimeout(r, 700));
    await Promise.all([this.auth.logout(), minDelay]);
    this.companies.clear();
    this.companies.mine.set([]);
    this.router.navigateByUrl('/login', { replaceUrl: true });
  }
}
